import '../typedefs'
import http from '@/http'

export default {
    /**
     * @param {SearchQuery} query
     * @returns {Promise<void>}
     */
    async searchProductInventoryTypes (query) {
        try {
            const response = await http.get('/products/inventory/types', {
                params: query
            })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
